import { render, staticRenderFns } from "./set10.vue?vue&type=template&id=9bd3e156&scoped=true&"
import script from "./set10.vue?vue&type=script&lang=js&"
export * from "./set10.vue?vue&type=script&lang=js&"
import style0 from "./set10.vue?vue&type=style&index=0&id=9bd3e156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd3e156",
  null
  
)

export default component.exports